import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

interface Props extends SvgIconProps {
  fill: string;
}

const IconLaptop: React.FC<Props> = ({ fill, ...other }) => (
  <SvgIcon viewBox="0 0 20 20" {...other}>
    <path
      d="M0.416679 14.1666H1.66668V4.99993C1.66668 4.08075 2.41414 3.33325 3.33336 3.33325H16.6667C17.5859 3.33325 18.3334 4.08071 18.3334 4.99993V14.1666H19.5834C19.8136 14.1666 20 14.3529 20 14.5833V14.9999C20 15.9191 19.2525 16.6666 18.3333 16.6666H1.66664C0.747459 16.6666 0 15.9191 0 14.9999V14.5833C0 14.3529 0.186367 14.1666 0.416679 14.1666ZM3.33332 14.1666H7.5C7.56469 14.1666 7.62859 14.1817 7.68637 14.2106L8.4318 14.5833H11.5682L12.3136 14.2106C12.3714 14.1817 12.4353 14.1666 12.5 14.1666H16.6667V4.99993H3.33336V14.1666H3.33332Z"
      fill={fill}
    />
    <rect x="4.16666" y="5.83325" width="11.6667" height="7.5" fill={fill} />
  </SvgIcon>
);

export default IconLaptop;
